import { NASELJA, NAZIVI_VEZE, uOkviru } from './konstante.js';
import { normalizirajTekst } from './evidencija.js';
import {
  PRAZNO_KUCANSTVO,
  ocistiTekst,
  ocistiKucniBroj,
  kljucAdrese,
  provjeriKucanstvo,
  pronadjiDuplikat,
} from './unosKucanstva.js';

export const POLJA_UVOZA = [
  ['naselje', 'Naselje', ['naselje']],
  ['kucni_broj', 'Kućni broj', ['kucni broj', 'broj kuce']],
  [
    'adresa',
    'Puna adresa',
    ['adresa kucanstva', 'adresa', 'adresa prikljucka'],
  ],
  [
    'nositelj',
    'Nositelj (puno ime)',
    [
      'nositelj prikljucka',
      'nositelj',
      'ime i prezime',
      'ime i prezime nositelja',
    ],
  ],
  ['nositelj_ime', 'Ime nositelja', ['ime nositelja', 'ime']],
  ['nositelj_prezime', 'Prezime nositelja', ['prezime nositelja', 'prezime']],
  ['broj_prikljucaka', 'Broj priključaka', ['broj prikljucaka']],
  ['godina_prikljucenja', 'Godina priključenja', ['godina prikljucenja']],
  [
    'kontakt',
    'Kontakt (puno ime)',
    ['podnositelj zahtjeva', 'podnositelj', 'kontakt', 'kontakt osoba'],
  ],
  ['kontakt_ime', 'Ime kontakta', ['ime kontakta']],
  ['kontakt_prezime', 'Prezime kontakta', ['prezime kontakta']],
  ['veza', 'Veza s nositeljem', ['veza s nositeljem', 'veza']],
  [
    'telefon',
    'Telefon',
    ['mobitel telefon', 'mobitel', 'telefon', 'broj telefona'],
  ],
  ['email', 'E-mail', ['e mail', 'email', 'e posta']],
  ['opis_lokacije', 'Opis lokacije', ['opis lokacije']],
  ['lat', 'Geografska širina', ['lat', 'latitude', 'geografska sirina']],
  [
    'lng',
    'Geografska dužina',
    ['lng', 'lon', 'longitude', 'geografska duzina'],
  ],
  ['napomena', 'Napomena (samo uz ručni pregled)', ['napomena']],
].map(([kljuc, naziv, nazivi]) => ({ kljuc, naziv, nazivi }));
const nazivStupca = (v) =>
  normalizirajTekst(ocistiTekst(v))
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
export function prepoznajStupce(zaglavlja) {
  return Object.fromEntries(
    POLJA_UVOZA.map((p) => [
      p.kljuc,
      zaglavlja.findIndex((z) => p.nazivi.includes(nazivStupca(z))),
    ]),
  );
}
export function prepoznajZaglavlje(redci) {
  let najbolji = { red: 0, bodovi: -1, stupci: {} };
  redci.slice(0, 30).forEach((r, red) => {
    const stupci = prepoznajStupce(r);
    const bodovi = Object.values(stupci).filter((i) => i >= 0).length;
    if (bodovi > najbolji.bodovi) najbolji = { red, bodovi, stupci };
  });
  return najbolji;
}
export function provjeriMapiranje(stupci) {
  const ima = (p) => Number.isInteger(stupci[p]) && stupci[p] >= 0;
  const poruke = [];
  if (!ima('nositelj') && !(ima('nositelj_ime') && ima('nositelj_prezime')))
    poruke.push('Poveži puno ime nositelja ili zasebno ime i prezime.');
  if (!ima('adresa') && !(ima('naselje') && ima('kucni_broj')))
    poruke.push('Poveži punu adresu ili zasebno naselje i kućni broj.');
  return poruke;
}
function rastaviIme(v, redoslijed) {
  const dijelovi = ocistiTekst(v).split(' ').filter(Boolean);
  if (dijelovi.length < 2) return { ime: dijelovi[0] || '', prezime: '' };
  return redoslijed === 'prezime-ime'
    ? { prezime: dijelovi.shift(), ime: dijelovi.join(' ') }
    : { prezime: dijelovi.pop(), ime: dijelovi.join(' ') };
}
function naseljeIzTeksta(v) {
  return (
    NASELJA.find(
      (n) => normalizirajTekst(n.naziv) === normalizirajTekst(ocistiTekst(v)),
    )?.naziv ?? ocistiTekst(v)
  );
}
function rastaviAdresu(v) {
  const tekst = ocistiTekst(v);
  const n = NASELJA.find((n) =>
    normalizirajTekst(tekst).startsWith(`${normalizirajTekst(n.naziv)} `),
  );
  return n
    ? {
        naselje: n.naziv,
        kucni_broj: ocistiKucniBroj(tekst.slice(n.naziv.length)),
      }
    : null;
}
export function pripremiUvoz(
  redci,
  redZaglavlja,
  stupci,
  kucanstva = [],
  redoslijed = 'ime-prezime',
) {
  const grupe = new Map();
  redci.slice(redZaglavlja + 1).forEach((red, indeks) => {
    const vrijednost = (polje) => ocistiTekst(red[stupci[polje]]);
    if (!POLJA_UVOZA.some((p) => vrijednost(p.kljuc))) return;
    const brojRetka = redZaglavlja + indeks + 2;
    const upozorenja = [];
    const nositelj =
      stupci.nositelj >= 0
        ? rastaviIme(vrijednost('nositelj'), redoslijed)
        : {
            ime: vrijednost('nositelj_ime'),
            prezime: vrijednost('nositelj_prezime'),
          };
    const adresa = rastaviAdresu(vrijednost('adresa'));
    const naselje =
      naseljeIzTeksta(vrijednost('naselje')) || adresa?.naselje || '';
    const kucniBroj =
      ocistiKucniBroj(vrijednost('kucni_broj')) || adresa?.kucni_broj || '';
    if (
      adresa &&
      ((naselje && naselje !== adresa.naselje) ||
        (vrijednost('kucni_broj') &&
          kucniBroj.toLowerCase() !== adresa.kucni_broj.toLowerCase()))
    )
      upozorenja.push(
        'Puna adresa i zasebni stupci nisu usklađeni. Provjeri adresu.',
      );
    if (vrijednost('adresa') && !adresa)
      upozorenja.push('Puna adresa ne počinje poznatim naseljem.');
    const podaci = {
      ...PRAZNO_KUCANSTVO,
      naselje,
      kucni_broj: kucniBroj,
      nositelj_ime: nositelj.ime,
      nositelj_prezime: nositelj.prezime,
      broj_prikljucaka: vrijednost('broj_prikljucaka') || '1',
      godina_prikljucenja: vrijednost('godina_prikljucenja'),
      opis_lokacije: vrijednost('opis_lokacije'),
      lat: vrijednost('lat'),
      lng: vrijednost('lng'),
    };
    // Napomene mogu sadržavati kontakte trećih osoba. Ostaju samo u pregledu do odluke čovjeka.
    if (
      podaci.lat &&
      podaci.lng &&
      !uOkviru(
        Number(podaci.lat.replace(',', '.')),
        Number(podaci.lng.replace(',', '.')),
      )
    )
      upozorenja.push(
        'Koordinate su izvan područja vodovoda; provjeri redoslijed širine i dužine.',
      );
    const izvornaNapomena = vrijednost('napomena');
    if (izvornaNapomena)
      upozorenja.push(
        'Napomena iz datoteke nije preuzeta. Pregledaj je prije uključivanja.',
      );
    const kontakti = [];
    const imaKontakt = [
      'kontakt',
      'kontakt_ime',
      'kontakt_prezime',
      'telefon',
      'email',
    ].some((p) => vrijednost(p));
    if (imaKontakt) {
      const osoba =
        stupci.kontakt >= 0 && vrijednost('kontakt')
          ? rastaviIme(vrijednost('kontakt'), redoslijed)
          : {
              ime: vrijednost('kontakt_ime'),
              prezime: vrijednost('kontakt_prezime'),
            };
      if (!osoba.ime && !osoba.prezime) {
        osoba.ime = nositelj.ime;
        osoba.prezime = nositelj.prezime;
        upozorenja.push(
          'Kontakt nema upisano ime; predložen je nositelj. Provjeri.',
        );
      }
      let veza = normalizirajTekst(vrijednost('veza')) || 'nositelj';
      if (veza === 'kcer' || veza === 'kcerka') veza = 'kci';
      if (!Object.hasOwn(NAZIVI_VEZE, veza)) {
        veza = 'ostalo';
        upozorenja.push(
          'Veza s nositeljem nije prepoznata; predloženo je ostalo.',
        );
      }
      const telefon = vrijednost('telefon')
        .replace(/\(\s*broj nositelja\s*\)/gi, '')
        .trim();
      if (telefon && !/^(0|\+)/.test(telefon))
        upozorenja.push(
          'Telefon ne počinje nulom ili međunarodnim prefiksom; provjeri je li Excel izgubio početnu nulu.',
        );
      kontakti.push({
        ...osoba,
        veza,
        telefon,
        email: vrijednost('email'),
        telefon_nositelja: /broj nositelja/i.test(vrijednost('telefon')),
        glavni: true,
      });
    }
    const kljuc = kljucAdrese(naselje, kucniBroj) || `redak-${brojRetka}`;
    if (!grupe.has(kljuc))
      grupe.set(kljuc, {
        oznaka: kljuc,
        podaci,
        kontakti: [],
        redci: [],
        upozorenja: [],
        napomene: [],
        nositelji: [],
        pregledano: false,
      });
    const g = grupe.get(kljuc);
    g.redci.push(brojRetka);
    g.upozorenja.push(...upozorenja);
    if (izvornaNapomena)
      g.napomene.push({ redak: brojRetka, tekst: izvornaNapomena });
    const punoIme = `${nositelj.ime} ${nositelj.prezime}`.trim();
    if (
      !g.nositelji.some(
        (n) => normalizirajTekst(n) === normalizirajTekst(punoIme),
      )
    )
      g.nositelji.push(punoIme);
    if (g.redci.length > 1) {
      for (const p of [
        'broj_prikljucaka',
        'godina_prikljucenja',
        'opis_lokacije',
        'lat',
        'lng',
      ]) {
        if (podaci[p] && g.podaci[p] && podaci[p] !== g.podaci[p])
          g.upozorenja.push(
            `Retci imaju različite vrijednosti za polje ${p.replaceAll('_', ' ')}. Odaberi ispravnu vrijednost.`,
          );
        else if (podaci[p] && !g.podaci[p]) g.podaci[p] = podaci[p];
      }
    }
    for (const k of kontakti) {
      const isti = g.kontakti.some((p) =>
        ['ime', 'prezime', 'veza', 'telefon', 'email'].every(
          (polje) =>
            normalizirajTekst(p[polje]) === normalizirajTekst(k[polje]),
        ),
      );
      if (!isti) g.kontakti.push({ ...k, glavni: g.kontakti.length === 0 });
    }
  });
  return [...grupe.values()].map((g) => {
    if (g.nositelji.length > 1) {
      g.upozorenja.push(
        'Na istoj adresi upisani su različiti nositelji. Čovjek treba odabrati ispravnog.',
      );
      g.podaci.nositelj_ime = '';
      g.podaci.nositelj_prezime = '';
    }
    g.upozorenja = [...new Set(g.upozorenja)];
    g.greske = provjeriKucanstvo(g.podaci, g.kontakti);
    g.postojece = pronadjiDuplikat(g.podaci, kucanstva);
    g.odabrano = !g.postojece && !g.greske.length && !g.upozorenja.length;
    return g;
  });
}

export function provjeriOdabraniUvoz(grupe) {
  const vidjeni = new Set();
  const poruke = [];
  for (const g of grupe) {
    const kljuc = kljucAdrese(g.podaci.naselje, g.podaci.kucni_broj);
    if (kljuc && vidjeni.has(kljuc))
      poruke.push(
        'Odabrana kućanstva imaju ponovljenu adresu. Ispravi adresu ili odaberi samo jedan zapis.',
      );
    if (kljuc) vidjeni.add(kljuc);
    poruke.push(...provjeriKucanstvo(g.podaci, g.kontakti));
  }
  return [...new Set(poruke)];
}
